// extracted by mini-css-extract-plugin
export default {"heading":"Approvers_heading__PPr-N","mainHeadline":"Approvers_mainHeadline__w1eSZ","mainContentTitle":"Approvers_mainContentTitle__dlp8v"};